import request from '@/services/interceptor.js'

/**
 * Recupera la configurazione export completa per la pagina di gestione.
 * @param {string} modulo  - 'serramenti' | 'persiane' | 'porte_interne'
 * @param {string} formato - 'excel' | 'pdf'
 */
export const get_config_export_admin = (modulo = 'serramenti', formato = 'excel', aziendaId = null) => {
    return request({
        url: `/config/export/${modulo}/${formato}/admin`,
        method: 'get',
        params: aziendaId != null ? { aziendaId } : {},
        loadingBar: true
    })
}


/**
 * Salva le modifiche (visibilità + ordinamento) in batch.
 * @param {string} modulo
 * @param {string} formato
 * @param {Array}  items  - [{ id, visibile, ordinamento }, ...]
 */
export const update_config_export_batch = (modulo = 'serramenti', formato = 'excel', items = [], aziendaId = null) => {
    return request({
        url: `/config/export/${modulo}/${formato}/admin`,
        method: 'put',
        data: { modulo, formato, items },
        params: aziendaId != null ? { aziendaId } : {},
        loadingBar: true
    })
}